import React, { useCallback, useEffect, useState } from "react";
import { setModalHelpOpen } from "../../actions/modals";
import { useDispatch } from "react-redux";
import Loading from "../Loading";
import { useNavigate } from "react-router-dom";
import {getBaseUrl} from "../../api/axios";

export default function SuccessPage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const printReciept = async () => {
    const win = window.open("about:blank", "newtab");
    win.location.href = `${getBaseUrl()}api/receipt/${data?.token}`;
  };

  const handleNavigateToHome = useCallback(() => navigate("/"), [navigate]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const res = await localStorage.getItem("success");
        if (res) {
          setData(JSON.parse(res));
        } else {
          handleNavigateToHome();
        }
      } catch (error) {
        handleNavigateToHome();
      }
    };
    loadData();
  }, [handleNavigateToHome]);

  const dispatch = useDispatch();

  const handleHelpClick = useCallback(
    () => dispatch(setModalHelpOpen()),
    [dispatch]
  );

  if (!data) {
    return <Loading />;
  }

  return (
    <div className="program__wrap donation-form__content success">
      <div className="donation_panel">
        <h3>
          {!!data?.donorFirstName
            ? `Thank you, ${data?.donorFirstName},`
            : "Thank you"}{" "}
          for choosing to partner with <span>{data?.donationRecipient}</span>.
          Your donation of{" "}
          <span>
            ${data?.donationValue}{" "}
            <span className="lowercase">{data?.donationSchedule}</span> makes a
            difference.
          </span>{" "}
        </h3>
        <p>
          We are thankful to God for your partnership in the gospel, as we
          proclaim Jesus Christ at university to present everyone mature in Him.
        </p>

        {data?.paymentType === "Direct Deposit" ? (
          <React.Fragment>
            <p>
              Please use your <span>unique reference code</span> so we can
              ensure your support is allocated according to your preferences.
            </p>
            <div className="success__block">
              <div className="success__row">
                <div className="success__label">Account name:</div>
                <div>AFES</div>
              </div>
              <div className="success__row">
                <div className="success__label">BSB:</div>
                <div>032-008</div>
              </div>
              <div className="success__row">
                <div className="success__label">Account number:</div>
                <div>130973</div>
              </div>
              <div className="success__row">
                <div className="success__label">Your reference code:</div>
                <div>{data?.webcode}</div>
              </div>
            </div>
            <div className="success__block push_b3">
              <div className="success__label">For international donations:</div>
              <div>SWIFT Banking Code: WPACAU2SXXX</div>
            </div>
          </React.Fragment>
        ) : (
          <p className="push_b3">
            Your receipt has been emailed to you, or you could{" "}
            <button onClick={printReciept} className="btn btn__link--text">
              <strong className="c_alpha">print</strong>
            </button>{" "}
            one now.
          </p>
        )}
        <p>
          Visit our{" "}
          <a
            data-remodal-target="help-modal"
            href="/faq"
            onClick={(e) => {
              e.preventDefault();
              handleHelpClick();
            }}
          >
            Help page
          </a>{" "}
          if you have further questions regarding your financial partnership.
        </p>
        <div className="success__block">
          <div className="success__foot">
            In Christ,
            <br />
            Peter Sorrenson
            <br />
            National Director
          </div>
        </div>
        <div className="buttons success__buttons">
          <button
            onClick={handleNavigateToHome}
            className="btn__solid save-button"
          >
            Support another worker
          </button>
        </div>
      </div>
    </div>
  );
}
